import type {Middleware} from '@linx-security/api-specs';

import {HTTPStatus} from '../types';

export const getForbiddenMiddleware = (onForbidden: () => void) => {
  return {
    post: async context => {
      if (!context.response) return context.response;
      if (context.response.status !== HTTPStatus.FORBIDDEN) return context.response;

      onForbidden();

      return context.response;
    },
  } satisfies Middleware;
};
